import { css } from '@emotion/css';

export const onboardingStyles = {
  modal: css`
    .ant-modal-content {
      border-radius: 16px;
      overflow: hidden;
      padding: 0;
    }

    .ant-modal-body {
      padding: 0;
    }

    .ant-modal-close {
      top: 16px;
      right: 16px;
      color: #666;
      font-size: 18px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(8px);
      border: 1px solid rgba(0, 0, 0, 0.1);
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 1);
        color: #333;
      }
    }
  `,

  container: css`
    display: flex;
    min-height: 500px;
    background: white;

    @media (max-width: 768px) {
      flex-direction: column;
      min-height: auto;
    }
  `,

  imageSection: css`
    flex: 1;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    position: relative;

    @media (max-width: 768px) {
      padding: 20px;
      min-height: 200px;
    }
  `,

  image: css`
    max-width: 100%;
    max-height: 100%;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  `,

  video: css`
    max-width: 100%;
    max-height: 100%;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  `,

  contentSection: css`
    flex: 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 768px) {
      padding: 30px 20px;
    }
  `,

  header: css`
    margin-bottom: 30px;
  `,

  badge: css`
    display: inline-block;
    background: #f0f2ff;
    color: #667eea;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 16px;
  `,

  title: css`
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  `,

  content: css`
    flex: 1;
    margin-bottom: 30px;
  `,

  paragraph: css`
    font-size: 16px;
    line-height: 1.6;
    color: #666;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  `,

  highlight: css`
    color: #667eea;
    font-weight: 600;
  `,

  buttonContainer: css`
    display: flex;
    justify-content: flex-end;
  `,

  nextButton: css`
    background: #ee8865;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    margin: 0 0.25em;

    &:hover {
      background: #f09a7dff;
    }

    &:active {
      transform: translateY(0);
    }
  `,
};
